import ModalItem from './ModalItem';

export default function InstantTransfer({ fields }) {
  return fields.map((field) => {
    const isRegion = Array.isArray(field);
    return isRegion ? (
      <div className="region_part">
        {field.map((v) => (
          <div className="region_item">
            <ModalItem field={v} key={field.value} />
          </div>
        ))}
      </div>
    ) : <ModalItem field={field} key={field.value} />;
  });
}
